import { styled } from '@ff/ui';
import Text from '@ff/ui/Text';

export const H1 = styled(Text)({
  fontSize: '30px',
  lineHeight: '36px',
});

export const H2 = styled(Text)({
  fontSize: '28px',
  lineHeight: '36px'
});

export const H3 = styled(Text)({
  fontSize: '20px',
  lineHeight: '28px',
});

// body/normal
export const P18 = styled(Text)({
  fontSize: '18px',
  lineHeight: '24px',
})

export const P16 = styled(Text)({
  fontSize: '16px',
  lineHeight: '18.75px'
});

export const P14 = styled(Text)({
  fontSize: '14px',
  lineHeight: '24px'
});

export const P13 = styled(Text)({
  fontSize: '13px',
  lineHeight: '24px'
});

export const P12 = styled(Text)({
  fontSize: '12px',
  lineHeight: '24px'
});

export const colors = {
  title: '#171A20',
  content1: '#5C5E62',
  content2: '#393C41',
  content3: '#3F3F43',
  content4: 'rgb(106, 108, 112)',
  message: '#9B4141',

  background1: 'rgba(253, 253, 253, 0.9)',
  background2: 'rgba(23, 26, 32, 0.05)',
  background3: 'rgba(246, 246, 246, 1)',
  background4: 'rgba(253, 253, 253, 1)',

  border1: '1px solid #CCCCCC',
  border2: '0.5px dashed #ACACAC',
  border3: '0.5px solid #ACACAC',
  border4: '1px solid rgba(57, 60, 65, 0.3)',
  border5: '0.5px solid rgba(23, 26, 32, 0.09)',
  border6: '1px solid rgba(23, 26,32, 0.1)',
  border7: '0.5px dashed rgb(201, 201, 209)',
  border8: '0.5px solid rgb(201, 201, 209)',
}